import { useState } from 'react';
import { TableInput } from '../../../../components/common';
import DatePickerMui from '../../../../components/common/DatePickerMui';
import moment from 'moment';
import {
  AddIconButton,
  CardIconButton,
  DeleteIconButton,
  RemoveIconButton,
} from '../../../../components/common/button/CustomIconButton';
import CustomSelect from '../../../../components/common/SelectField';
import { Grid, MenuItem } from '@mui/material';
import AutocompleteMuiCustom from '../../../../components/common/AutocompleteMuiCustom';
import AutocompleteMuiCustomRevised from '../../../../components/common/tableinputs/AutocompleteMuiCustomRevised';
import formatDate from '../../../../components/common/formatDate';
import { useNavigate } from 'react-router-dom';

interface IProps {
  item: any;
  isView: any;
  handleDelete: any;
  index: number;
  machineData: any;
  breakdownData: any;
  moduleData: any;
}
const getTotalCumulative = (moduleData:any)=>{
  for(let i=0; i<moduleData.length; i++){
    if(i==0)
     moduleData[i].cum_down_time = +moduleData[i].down_time;
    else 
     moduleData[i].cum_down_time = +moduleData[i-1].cum_down_time + +moduleData[i].down_time;
  }
  const total_down_time = +moduleData[moduleData.length-1].cum_down_time;
  for(let i=0; i<moduleData.length; i++){
    moduleData[i].per_cum_down_time = +((+moduleData[i].cum_down_time * 100)/(+total_down_time)).toFixed(2);
  }
  console.log("moduleData", moduleData)
} 
const TBodyRow = ({
  item,
  index,
  isView,
  handleDelete,
  machineData,
  breakdownData,
  moduleData,
}: IProps) => {
  const [rowRender, setRowRender] = useState(false);

  const handleChange = (e: any) => {
    item[e.target.name] = e.target.value;
    setRowRender((prev: any) => !prev);
  };

  return (
    <>
      <tr>
        <td style={{ textAlign: 'center', minWidth: '100px' }}>{index + 1}</td>
        <td style={{ textAlign: 'center', minWidth: '200px' }}>
          <DatePickerMui
            label=""
            onChange={(date) => {
              item.date = moment(date || null);
              setRowRender((prev: any) => !prev);
            }}
            value={(item?.date && moment(item?.date)) || null}
          />
          {/* {formatDate(item?.date)} */}
        </td>
        <td>
          {/* <AutocompleteMuiCustom
            id="Machine"
            label=""
            option_name="machine_no"
            arrayofObj={machineData}
            value={item?.machine_id || ''}
            onChange={(e, value) => {
              item.machine_id = value;
              setRowRender((prev: any) => !prev);
            }}
          /> */}
          <AutocompleteMuiCustomRevised
            id="machine_id"
            label=""
            option_name="machine_no"
            key={'machine_no'}
            arrayofObj={machineData}
            value={item?.machine_id || ''}
            onChange={(e, value) => {
              item.machine_id = value;
              setRowRender((prev: any) => !prev);
            }}
            sx={{ width: '200px', padding: '2px' }}
          />
          {/* {item?.machine_id?.machine_no} */}
        </td>
        <td style={{ textAlign: 'center', minWidth: '200px' }}>
          {item?.machine_id?.location_id?.location_name}
        </td>

        <td style={{ textAlign: 'center', minWidth: '200px' }}>
          <TableInput
            isView={isView}
            type="number"
            name="down_time"
            value={item?.down_time ?? null}
            onChange={(e) => {
              handleChange(e);
              getTotalCumulative(moduleData);
            }}
          />
          {/* {item?.total_down_time || item?.down_time} */}
        </td>
        <td style={{ textAlign: 'center', minWidth: '200px' }}>
          {moduleData[index].cum_down_time || item?.curr_down_time } 
        </td>
        <td style={{ textAlign: 'center', minWidth: '200px' }}>
          {moduleData[index].per_cum_down_time ||item?.per_curr_down_time}
        </td>
        <td style={{ minWidth: '200px' }}>
          {/* <AutocompleteMuiCustom
            id="Breakdown"
            label=""
            option_name="breakdown_name"
            arrayofObj={breakdownData}
            value={item?.breakdown_id || ''}
            onChange={(e, value) => {
              item.breakdown_id = value;
              setRowRender((prev: any) => !prev);
            }}
          /> */}
          <AutocompleteMuiCustomRevised
            id="breakdown_id"
            label=""
            option_name="breakdown_name"
            key={'breakdown_name'}
            arrayofObj={breakdownData}
            value={item?.breakdown_id || ''}
            onChange={(e, value) => {
              item.breakdown_id = value;
              setRowRender((prev: any) => !prev);
            }}
            sx={{ width: '200px', padding: '2px' }}
          />
          {/* {item?.breakdown_id?.breakdown_name} */}
        </td>
        {/* <td style={{ textAlign: 'center', minWidth: '300px' }}>
          <TableInput
            isView={isView}
            type="text"
            name="reason"
            value={item?.reason ?? null}
            onChange={(e) => {
              handleChange(e);
            }}
          />
          {item?.reason}
        </td> */}
        {/* <td style={{ textAlign: 'center', minWidth: '200px' }}>
          <TableInput
            isView={isView}
            type="text"
            name="action_plan"
            value={item?.action_plan ?? null}
            onChange={(e) => {
              handleChange(e);
            }}
          />
          {item?.action_plan}
        </td>
        <td style={{ textAlign: 'center', minWidth: '200px' }}>
         {item?.sparePart_id?.key_spares} {item?.custom_non_critical_name || ""} ({item?.sparePart_id?.type_of_part})
        </td>
        <td style={{ textAlign: 'center', minWidth: '200px' }}>
          {item?.cost}
        </td> */}
        {/* <td style={{ textAlign: 'center', minWidth: '200px' }}>
          <TableInput
            isView={isView}
            type="text"
            name="attended_by"
            value={item?.attended_by ?? null}
            onChange={(e) => {
              handleChange(e);
            }}
          />
          {item?.attended_by}
        </td> */}
        {/* <td style={{ textAlign: 'center', minWidth: '200px' }}>
          <TableInput
            isView={isView}
            type="text"
            name="remarks"
            value={item?.remarks ?? null}
            onChange={(e) => {
              handleChange(e);
            }}
          />
        </td> */}
        {/* <td style={{ textAlign: 'center', minWidth: '200px' }}>
          <TableInput
            isView={isView}
            type="text"
            name="analysis_down_time"
            value={item?.analysis_down_time ?? null}
            onChange={(e) => {
              handleChange(e);
            }}
          />
        
          <CardIconButton
              tooltipTitle="Analysis"
              onClick={() => {
                navigate(
                  `/common/createDownTimeAnalysis/${item?._id}?isView=false`
                );
              }}
            />
        </td> */}
        {!isView && (
          <td style={{ textAlign: 'center' }}>
            <DeleteIconButton
              tooltipTitle="DELETE"
              onClick={() => {
                handleDelete(item?._id, index);
              }}
            />
          </td>
        )}
      </tr>
    </>
  );
};

export default TBodyRow;
